import NormalBanner from './NormalBanner';
import SpecialBanner from './SpecialBanner';
import TalkBoard from './TalkBoard';
import {IAdBannerType, IAdminBannerComponent} from '../../type';

interface IProps {
  type: IAdBannerType;
  adminAd: IAdminBannerComponent;
}

export default function AdminBanner({type, adminAd}: IProps) {
  switch (type) {
    case 'adMoment':
      return <TalkBoard {...adminAd} />;
    case 'adNormalEvent':
    case 'adBigMoment':
      return <NormalBanner {...adminAd} />;
    case 'adSpecialEvent':
      return <SpecialBanner {...adminAd} />;
    default:
      return null;
  }
}
